<template>
    <div v-loading="loading" style="min-height:140px">
        <el-table border :data="invoices" style="width: 100%;" header-row-class-name="d-none" show-header="false">
            <el-table-column>
                <template #default="{ row }">
                    <div class="d-flex justify-between items-center" style="align-items:center;">
                        <div class="d-flex flex-column">
                            <div style="font-size:17px;font-weight:600;">
                                №{{ row.invoiceNumber }}
                                <el-tag v-if="row.isActive" style="margin-left:4px;" type="success" size="small">
                                    Aktiv
                                </el-tag>
                            </div>
                            <div style="margin:4px 0 2px 0;">
                                Məbləğ: <b>{{ formatAmount(row.agreementAmount) }}</b> AZN
                                <span v-if="row.preAgreementExpense" style="color:#666; margin-left:10px;">
                                    Əlavə xərc: <b>{{ formatAmount(row.preAgreementExpense) }}</b> AZN
                                </span>
                            </div>
                            <div style="font-size:13px;color:#888;">
                                {{ formatDateTime(row.createDate) }}
                            </div>
                        </div>
                        <button type="button" class="btn btn-outline-info"
                            style="margin-left:auto; padding:4px 12px; font-size:14px;" @click="openPrint(row.id)">
                            <b>Baxış</b>
                        </button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="!loading && !invoices.length" description="İnvoys yoxdur" />


    </div>
</template>

<script>
import { GetInvoiceList } from "@/project/Source/invoices";
// import SoftButton from "@/components/SoftButton.vue";

export default {
    // components: { SoftButton },
    props: {
        participantId: [String, Number]
    },
    emits: ['close-timeline'], 
    data() {
        return {
            invoices: [],
            loading: false,
            printDialogVisible: false,
            selectedInvoice: null
        };
    },
    mounted() {
        this.fetch();
    },
    methods: {
        async fetch() {
            this.loading = true;
            try {
                const resp = await GetInvoiceList(this.participantId);
                const rows = resp.data.data || [];
                console.log("Fetched invoices:", rows);
                const byId = {};
                for (const row of rows) {
                    if (!byId[row.id]) {
                        byId[row.id] = {
                            ...row,
                            payments: []
                        };
                    }
                    if (row.paymentDate && row.amount != null) {
                        byId[row.id].payments.push({
                            paymentDate: row.paymentDate,
                            amount: row.amount
                        });
                    }
                }
                this.invoices = Object.values(byId).sort(
                    (a, b) => new Date(b.createDate) - new Date(a.createDate)
                );
            } finally {
                this.loading = false;
            }
        },
        formatDate(dt) {
            if (!dt) return "-";
            const d = new Date(dt);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            return `${dd}.${mm}.${yyyy}`;
        },
        formatDateTime(dt) {
            if (!dt) return "-";
            const d = new Date(dt);
            const dd = String(d.getDate()).padStart(2, '0');
            const mm = String(d.getMonth() + 1).padStart(2, '0');
            const yyyy = d.getFullYear();
            const hh = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            return `${dd}.${mm}.${yyyy} ${hh}:${min}`;
        },
        formatAmount(value) {
            if (value == null) return "-";
            let parts = Number(value).toFixed(2).split('.');
            parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            return parts.join(',');
        },
        async openPrint(invoiceId) {
            await this.fetch();
            const inv = this.invoices.find(x => x.id == invoiceId);
            if (!inv) {
                this.$message.error("İnvoys tapılmadı");
                return;
            }
            this.$emit('close-timeline'); 
            this.$emit('open-print', inv); 
        }

    }
};
</script>

<style scoped>
.invoice-table,
.invoice-table th,
.invoice-table td,
.payment-table,
.payment-table th,
.payment-table td {
    border: 1.6px solid #606266 !important;
}

td {
    padding: 12px 24px !important;
}


.badge-active {
    background: #eafbe7;
    color: #299c47;
    border-radius: 6px;
    padding: 2px 10px;
    font-size: 13px;
    margin-left: 8px;
}

.print-content {
    background: #fff;
    padding: 24px 28px 36px 28px;
    min-height: 440px;
}

.invoice-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #222;
    padding-bottom: 16px;
}

.invoice-title {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 1px;
}

.invoice-info {
    display: flex;
    justify-content: space-between;
    margin-top: 18px;
    margin-bottom: 8px;
}

.invoice-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 16px;
    font-size: 15px;
}

.payment-schedule {
    margin-top: 28px;
}

.payment-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 14px;
}

.invoice-footer {
    margin-top: 32px;
    display: flex;
    justify-content: space-between;
}

/* Print-specific styles */
@media print {
    body {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
    }

    #printButton {
        display: none;
    }
}
</style>